import Shubham from './shubham.jpeg';
import Neha from './neha.jpeg';
import Payal from './payal.jpeg'
import Nishata from './nishata.jpeg'
import Aman from './aman.jpeg'
import Ashka from './ashka.jpeg'

const TEAM_DATA = [
  {
    imageUrl: Neha,
    title: 'Brand Designer',
    skills: ['Brand', 'Graphic', 'GIF'],
  },
  {
    imageUrl: Ashka,
    name: 'Ashka Budhraja',
    title: 'Figma Designer',
    skills: ['UX', 'Mobile', 'Product'],
  },
  {
    imageUrl: Aman,
    name: 'Aman Pandey',
    title: 'Software Engineer',
    skills: ['Full Stack', 'App', 'Backend'],
  },
  {
    imageUrl: Nishata,
    name: 'Nishtha Thakkar',
    title: 'Software Engineer',
    skills: ['Frontend', 'Web', 'Python'],
  },
  {
    imageUrl: Payal,
    name: 'Payal Kanwar',
    title: 'Senior Engineer',
    skills: ['AWS', 'CI/CD', 'DevOps'],
  },
  {
    imageUrl: Shubham,
    name: 'Shubham Kumawat',
    title: 'Software Engineer',
    skills: ['Backend', 'App', 'MERN'],
  },
  
];

export default TEAM_DATA;
